import { EntityType } from './entity-type';
import { InvestmentJurisdiction } from './investment-jurisdiction';
import { ResidencyJurisdiction } from './residency-jurisdiction';
import { TaxPolicyStatus } from './tax-policy-status';
import { SecurityType } from './security-type';

export class TaxPolicy {
  name!: string;
  taxPolicyId!: number;
  taxRuleId!: number;
  investmentJurisdiction?: InvestmentJurisdiction;
  residencyJurisdiction?: ResidencyJurisdiction;
  entityType?: EntityType;
  isActive?: boolean;
  taxPolicyStatus?: TaxPolicyStatus;
  securityType?: SecurityType;
  generalRate?: boolean;
}
